import { lazy } from 'react';

export const LoginPage = lazy(() => import('./login-page'));
